import { type IPreviewWorkflowData, WorkflowsApi, WorkflowStatus } from 'entities/Workflow'
import { EnrollSearchStore } from 'widgets/EnrollSearch'

export type WorkflowEnrollSearchStore = EnrollSearchStore<IPreviewWorkflowData, string>

export const createWorkflowEnrollSearchStore = (): WorkflowEnrollSearchStore =>
  new EnrollSearchStore<IPreviewWorkflowData, string>({
    perPage: 10,
    getKey: (item) => item.id,
    fetchItems: async ({ term, offset, limit, cancelToken }) => {
      const page = Math.floor(offset / limit) + 1
      const {
        data: { payload, meta },
      } = await WorkflowsApi.getWorkflows(
        {
          preview: true,
          'page[size]': limit,
          'page[pointer]': page,
          'filters[name]': term || null,
          'filters[status]': WorkflowStatus.Active,
        },
        { cancelToken }
      )
      return { items: payload, total: meta.pagination.total }
    },
  })
